import React from "react";
import Backdrop from "@mui/material/Backdrop";
import { Stack, styled } from "@mui/material";
import gif from "../../assests/logo/rohan-pfp-anim.gif";

const CustomLoaderWrapper = styled(Stack)(({ theme }) => ({
  width: "100px",
  height: "auto",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "20px",
  overflow: "hidden",
}));

const CustomLoader = ({ open, onClose }) => {
  return (
    <div>
      <Backdrop
        sx={{ color: "#fff", zIndex: 99999999999 }}
        open={open}
        onClose={onClose}
      >
        <CustomLoaderWrapper>
          <img
            src={gif}
            alt="Loading..."
            style={{
              width: "100%",
              height: "auto",
              objectFit: "contain",
            }}
          />
        </CustomLoaderWrapper>
      </Backdrop>
    </div>
  );
};

export default CustomLoader;
